'use strict';

var _asyncToGenerator = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _regeneratorRuntime = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _wrapAsyncGenerator = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/wrapAsyncGenerator");

var _awaitAsyncGenerator = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/awaitAsyncGenerator");

var _asyncIterator = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncIterator");

var _asyncGeneratorDelegate = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncGeneratorDelegate");

var Reader = require('it-reader');

var Writer = require('it-pushable');

var defer = require('p-defer'); // Convert a duplex stream into a reader and writer and rest stream


module.exports = function (stream) {
  var writer = Writer(); // Write bytes on demand to the sink

  var reader = Reader(stream.source); // Read bytes on demand from the source
  // Waits for a source to be passed to the rest stream's sink

  var sourcePromise = defer();
  var sinkPromise = stream.sink(_wrapAsyncGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var source;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            return _context.delegateYield(_asyncGeneratorDelegate(_asyncIterator(writer), _awaitAsyncGenerator), "t0", 1);

          case 1:
            _context.next = 3;
            return _awaitAsyncGenerator(sourcePromise.promise);

          case 3:
            source = _context.sent;
            return _context.delegateYield(_asyncGeneratorDelegate(_asyncIterator(source), _awaitAsyncGenerator), "t1", 5);

          case 5:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }))());
  var rest = {
    sink: function sink(source) {
      sourcePromise.resolve(source);
      return sinkPromise;
    },
    source: reader
  };
  return {
    reader: reader,
    writer: writer,
    stream: rest,
    rest: function rest() {
      return writer.end();
    },
    write: writer.push,
    read: function () {
      var _read = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return reader.next();

              case 2:
                return _context2.abrupt("return", _context2.sent.value);

              case 3:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      function read() {
        return _read.apply(this, arguments);
      }

      return read;
    }()
  };
};